import { Button, ButtonProps } from "antd";

import { EItemType } from "../../interfaces";

interface IProps extends ButtonProps {
  label: string;
  currentItemType?: EItemType;
}

export default function InputActionButton({
  style,
  label,
  currentItemType,
  ...props
}: IProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Button
        style={{
          borderRadius: 36,
          outline: 0,
          width: 36,
          height: 36,
          ...style,
        }}
        {...props}
      />

      <span
        style={{
          fontSize: 10,
          color: currentItemType === EItemType.COLLECT ? "#FFFFFF" : "#2D66A2"
        }}
      >
        {label}
      </span>
    </div>

  )
}
